import React from 'react';
import { Route } from 'react-router-dom';
import HousingPage from './HousingPage';

export const routes = [<Route key="1" path="/projects/:projectId/housing" component={HousingPage} />];
